// import {getDiscount} from './discounts';

export const taxRate = 0.09;
export function rent(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return Math.round(stayDays.reduce((rent, day) => rent + Number(day.rate), 0) * 100) / 100;
}

function discountPeriod(stayDays, pets) {

    if (stayDays.length < 7) {
        return  1;
    } else if (stayDays.length < 14) {
        return  7;
    } else if (stayDays.length < 28) {
        return 14;
    } else {
        return 28;
    }
}

export function discountPercent(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    const discount = stayDays[0].discounts.find(discount => discount.days === discountPeriod(stayDays, pets));
    return discount && discount.percent !== null ? Number(discount.percent) : null;
}

export function discount(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }

    // // METHOD 1: Apply discount for arrival date to entire block
    // return discountPercent(stayDays, pets)
    //     ? (Math.round(rent(stayDays, pets) * discountPercent(stayDays, pets)) / 100)
    //     : 0
    // ;

    // METHOD 2: Apply discount for each day
    return stayDays.reduce((acc, day) => {
        // console.debug('day', day);
        const discount = day.discounts.find(discount => discount.days === discountPeriod(stayDays, pets));
        // console.debug('discount', discount);
        return acc + (discount && discount.percent ? (Math.round(Number(day.rate) * Number(discount.percent) / 100)) : 0);
    }, 0);
}

export function petFee(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return (pets > 0) ? 100 : 0;
}

export function subtotal(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return rent(stayDays, pets) + petFee(stayDays, pets) - discount(stayDays, pets);
}

export function security(stayDays, pets) {
    return 0;
}

export function tax(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return subtotal(stayDays, pets) * taxRate;
}

export function total(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return subtotal(stayDays, pets) + tax(stayDays, pets) + security(stayDays, pets);
}

export function deposit(stayDays, pets) {
    if (stayDays.length === 0) {
        return null;
    }
    return subtotal(stayDays, pets) / 2;
}

